import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=355ae9a0&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"
import style0 from "./CreateProject.vue?vue&type=style&index=0&id=355ae9a0&prod&scoped=true&lang=css"
import style1 from "./CreateProject.vue?vue&type=style&index=1&id=355ae9a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ae9a0",
  null
  
)

export default component.exports